<svg [class]="rotate" [attr.height]="height" [attr.width]="width" [attr.viewBox]="viewBox">
	<use [attr.height]="height" [attr.width]="width" [attr.viewBox]="viewBox" [attr.xlink:href]="iconPath + iconName + '#' + iconId"></use>
</svg>
